import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "../../../common/AppBar";
import Snackbar from "../../../common/Snackbar";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml";
import { getAllSectionsForPart } from "../../../redux/sectionSlice";
import {
  getAllAttachmentsForStep,
  getAllAttachmentsForSubstep,
  getAllCanvasesForStep,
  getAllCanvasesForSubstep,
  getAllFormsForStep,
  getAllFormsForSubstep,
  getAllRichTextsForStep,
  getAllRichTextsForSubstep,
  getAllStepsForSection,
  getAllSubstepsForStep,
  getAllVideosForStep,
  getAllVideosForSubstep,
} from "../../../redux/stepSlice";
import VersionHistoryCopyAppBar from "../../../common/VersionHistoryCopyAppBar";
import { getPages, renderPreview, renderVideo } from "../plugins/utils";
import {
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../../SectionElements/plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
const ProcedureStepCopy = () => {
  const [targetSectionData, setTargetSectionData] = useState({});
  const [selectedNode, setSelectedNode] = useState("");
  const [selectedStepInfo, setSelectedStepInfo] = useState(null);
  const [selectionType, setSelectionType] = useState(null); // 'section' or 'step'

  const { sections } = useSelector((state) => state.section);
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;

  let richTextsCounter = {};

  const location = useLocation();
  const navigate = useNavigate();
  let attachmentCounter = 1;

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const {
    type,
    partNumber,
    description,
    revision,
    status,
    title,
    partId,
    fromTreeId,
    fromSectionId,
    revisionId,
    fromSiblingOrder,
    fromPartNumber,
    fromRevision,
    toPartNumber,
    toRevision,
    richTextsByStep,
    attachmentsByStep,
    canvasesByStep,
    formsByStep,
    videosByStep,
    section,
    steps,
    toRevisionId,
    step,
    fromPartId,
    fromRevisionId,
    sourceSectionIndex,
    toType,
    copyTitle,
  } = location.state;
  const [selectedSectionIndex, setSelectedSectionIndex] = useState(null);
  const [isProcedureSelected, setIsProcedureSelected] = useState(false);
  const dispatch = useDispatch();

  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const sortedSections = [...sections];

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  useEffect(() => {
    dispatch(getAllSectionsForPart({ partId, revisionId: toRevisionId }));
  }, [dispatch, partId, revisionId]);

  useEffect(() => {
    if (sections.length > 0) {
      sections.forEach(async (section) => {
        await dispatch(
          getAllStepsForSection({
            partId,
            revisionId,
            sectionId: section.section_tree_node_id,
          })
        );
      });
    }
  }, [sections, dispatch, partId, revisionId]);

  useEffect(() => {
    if (Object.keys(stepsBySection).length > 0) {
      Object.entries(stepsBySection).forEach(([sectionId, steps]) => {
        steps.forEach((step) => {
          const { step_tree_node_id: stepId } = step;

          // // Fetch for step-level content
          dispatch(
            getAllRichTextsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllFormsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllVideosForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllAttachmentsForStep({ partId, revisionId, sectionId, stepId })
          );
          dispatch(
            getAllCanvasesForStep({ partId, revisionId, sectionId, stepId })
          );

          // Fetch substeps (async)
          dispatch(
            getAllSubstepsForStep({ partId, revisionId, sectionId, stepId })
          ).then((action) => {
            const substeps = action.payload?.substeps || [];
            substeps.forEach((substep) => {
              const substepId = substep.sub_step_tree_node_id;

              dispatch(
                getAllRichTextsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllFormsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllVideosForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllAttachmentsForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
              dispatch(
                getAllCanvasesForSubstep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                  substepId,
                })
              );
            });
          });
        });
      });
    }
  }, [sections, dispatch, partId, revisionId, stepsBySection]);

  const handleMoveUp = () => {
    const targetSectionIndex = selectedSectionIndex;

    // Navigate to preview screen
    navigate("/procedure-step-copy-preview", {
      state: {
        ...location.state,
        moveType: "up",
        sourceSectionIndex,

        copyTitle: `${copyTitle} to ${toPartNumber} Rev ${toRevision} ${
          selectedSectionIndex !== null
            ? `Section ${selectedSectionIndex + 1}`
            : selectionType === "step"
            ? `Step ${targetSectionData.stepIndex + 1}`
            : ""
        }`,

        targetSectionIndex: selectedSectionIndex,
        revision,
        type,
        partNumber,
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        richTextsByStep,
        attachmentsByStep,
        canvasesByStep,
        formsByStep,
        videosByStep,
        fromPartId,
        fromRevisionId,
        section,
        steps,
        step,
        fromPartId,
        fromRevisionId,
        status,
        toType,
        description,
        toPartNumber,
        substepsByStep: location.state.substepsByStep,

        treeNode: `Section ${
          sourceSectionIndex !== undefined && sourceSectionIndex !== null
            ? sourceSectionIndex + 1
            : "Unknown"
        } > ${title.split(" ")[0]} ${title.split(" ")[1]}`,

        title: `${title} from ${fromPartNumber} Rev ${fromRevision}`,
      },
    });
  };

  const handleMoveBelow = () => {
    const targetSectionIndex = selectedSectionIndex;

    // if (targetSectionIndex === null) {
    //   showSnackbar("Please select a target section to copy to", "error");
    //   return;
    // }

    // if (sourceSectionIndex === targetSectionIndex) {
    //   showSnackbar("Cannot copy section to its current position", "error");
    //   return;
    // }

    // if (targetSectionIndex <= sourceSectionIndex) {
    //   showSnackbar("Target section must be below the source section", "error");
    //   return;
    // }
    // console.log(sourceSectionIndex, targetSectionIndex);
    // Navigate to preview screen
    navigate("/procedure-step-copy-preview", {
      state: {
        ...location.state,
        moveType: "below",
        sourceSectionIndex,
        copyTitle: `${copyTitle} to ${toPartNumber} Rev ${toRevision} ${
          selectedSectionIndex !== null
            ? `Section ${selectedSectionIndex + 1}`
            : selectionType === "step"
            ? `Step ${targetSectionData.stepIndex + 1}`
            : ""
        }`,
        targetSectionIndex: selectedSectionIndex,
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        richTextsByStep,
        attachmentsByStep,
        canvasesByStep,
        formsByStep,
        videosByStep,
        fromPartId,
        fromRevisionId,
        section,
        steps,
        step,
        fromPartId,
        fromRevisionId,
        status,
        toType,
        description,
        toPartNumber,
        substepsByStep: location.state.substepsByStep,

        treeNode: `Section ${
          sourceSectionIndex !== undefined && sourceSectionIndex !== null
            ? sourceSectionIndex + 1
            : "Unknown"
        } > ${title.split(" ")[0]} ${title.split(" ")[1]}`,

        title: `${title} from ${fromPartNumber} Rev ${fromRevision}`,
      },
    });
  };

  const handleMoveInto = () => {
    // Get the last section index
    const lastSectionIndex = sortedSections.length - 1;

    // Check if the source section is already the last section
    // if (sourceSectionIndex === lastSectionIndex) {
    //   showSnackbar("This section is already at the last position", "error");
    //   return;
    // }

    // Navigate to preview screen
    navigate("/procedure-step-copy-preview", {
      state: {
        ...location.state,
        moveType: "into", // Use "below" instead of "into" to move after the last section
        sourceSectionIndex,
        copyTitle: `${copyTitle} to ${toPartNumber} Rev ${toRevision} ${
          selectedSectionIndex !== null
            ? `Section ${selectedSectionIndex + 1}`
            : selectionType === "step"
            ? `Step ${targetSectionData.stepIndex + 1}`
            : ""
        }`,
        targetSectionIndex: lastSectionIndex,
        moveIntoProcedure: true, // Add a flag to indicate this is a move into procedure
        revisionId,
        targetSectionData,
        partId,
        fromSectionId,
        fromTreeId,
        fromSiblingOrder,
        richTextsByStep,
        attachmentsByStep,
        canvasesByStep,
        formsByStep,
        videosByStep,
        fromPartId,
        fromRevisionId,
        section,
        steps,
        step,
        fromPartId,
        fromRevisionId,
        status,
        toType,
        description,
        toPartNumber,
        substepsByStep: location.state.substepsByStep,

        treeNode: `Section ${
          sourceSectionIndex !== undefined && sourceSectionIndex !== null
            ? sourceSectionIndex + 1
            : "Unknown"
        } > ${title.split(" ")[0]} ${title.split(" ")[1]}`,

        title: `${title} from ${fromPartNumber} Rev ${fromRevision}`,
      },
    });
  };
  const handleProcedureCheckboxChange = () => {
    // When procedure is selected, clear any section selection
    if (!isProcedureSelected) {
      setSelectedSectionIndex(null);
    }
    setIsProcedureSelected(!isProcedureSelected);
  };

  // Create buttons array conditionally based on selection state
  const getButtons = () => {
    const buttons = [];
    if (selectionType === "step") {
      buttons.push({ label: "Paste Above", onClick: handleMoveUp });
      buttons.push({ label: "Paste Below", onClick: handleMoveBelow });
    } else if (selectedSectionIndex !== null) {
      buttons.push({ label: "Paste Into", onClick: handleMoveInto });
    }
    return buttons;
  };

  return (
    <div>
      <VersionHistoryCopyAppBar
        showBackButton={false}
        showTablesDropdown={false}
        showCancelButton={true}
        title={
          <>
            Copying <span style={{ textDecoration: "underline" }}>{title}</span>{" "}
            from {fromPartNumber} Rev {fromRevision} to {toPartNumber} Rev{" "}
            {toRevision}{" "}
            <span style={{ textDecoration: "underline" }}>
              {selectedSectionIndex !== null
                ? "Section " + (selectedSectionIndex + 1)
                : selectionType === "step"
                ? "Step " + (targetSectionData.stepIndex + 1)
                : ""}
            </span>
          </>
        }
        buttons={getButtons()}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 0",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            <span style={{ fontSize: "19px", fontWeight: 600 }}>
              {toType} {toPartNumber}
            </span>
          </label>
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>{status}</span>
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>

      {sortedSections
        .sort((a, b) => {
          const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
          const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

          const orderCompare = compareSiblingOrders(orderA, orderB);
          if (orderCompare !== 0) return orderCompare;

          // Fallback: compare created_at
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA; // latest comes first
        })
        .map((section, index) => {
          const selectedSection = index === selectedSectionIndex;
          const sectionSteps =
            stepsBySection[section.section_tree_node_id] || [];

          const maxSiblingOrder = sectionSteps.length
            ? Math.max(
                ...sectionSteps.map((step) =>
                  parseFloat(
                    step.sibling_order ||
                      step.procedure_tree?.sibling_order ||
                      0
                  )
                )
              )
            : 0;

          return (
            <div
              className="header-spacing"
              key={section.section_tree_node_id}
              style={{
                margin: "20px 0",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedSection}
                  onChange={() => {
                    // If clicking the already selected checkbox, unselect it
                    if (selectedSectionIndex === index) {
                      setSelectedSectionIndex(null);
                      setTargetSectionData({});
                      setSelectionType(null);
                    } else {
                      setSelectedStepInfo({});
                      setSelectionType("section");
                      setSelectedSectionIndex(index);
                      // When a section is selected, deselect procedure
                      setIsProcedureSelected(false);
                      setTargetSectionData({
                        sectionId: section.section_tree_node_id,
                        siblingOrder: section.sibling_order,
                        sectionTreeId: section.procedure_tree_ref,
                        maxSiblingOrder,
                      });
                    }
                  }}
                />

                <h2 style={{ margin: 0, color: "#0066cc", fontSize: "20px" }}>
                  Section {index + 1}
                </h2>
                {selectedSection && (
                  <span
                    style={{
                      marginLeft: "12px",
                      fontSize: "14px",
                      color: "#666",
                      fontStyle: "italic",
                    }}
                  >
                    {/* (Current Section Being Moved) */}
                  </span>
                )}
              </label>
              <hr />
              <hr />
              <div>{section.section_name}</div>
              <div>{section.short_description}</div>

              {/* Steps for this section */}
              {(stepsBySection[section.section_tree_node_id] || []).map(
                (step, stepIndex) => {
                  const stepId = step.step_tree_node_id;

                  const stepsBeforeThisSection = sortedSections
                    .slice(0, index)
                    .reduce(
                      (acc, s) =>
                        acc +
                        (stepsBySection[s.section_tree_node_id]?.length || 0),
                      0
                    );
                  const globalStepNumber =
                    stepsBeforeThisSection + stepIndex + 1;

                  const myVideos = videos[stepId] || [];
                  const myForms = forms[stepId] || [];
                  const myCanvases = canvases[stepId] || [];
                  const myRichTexts = canvases[stepId] || [];

                  const currentRichTextCounter = richTextCounter;

                  // Update counters for next step
                  //attachmentCounter += myAttachments.length;
                  // videoCounter += myVideos.length;
                  // formCounter += myForms.length;
                  // canvasCounter += myCanvases.length;
                  // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                  richTextsCounter[stepId] = currentRichTextCounter;

                  const combinedItems = [
                    ...(richTexts[stepId] || []).map((item) => ({
                      ...item,
                      type: "richText",
                    })),
                    ...(forms[stepId] || []).map((item) => ({
                      ...item,
                      type: "form",
                    })),
                    ...(attachments[stepId] || []).map((item) => ({
                      ...item,
                      type: "attachment",
                    })),
                    ...(canvases[stepId] || []).map((item) => ({
                      ...item,
                      type: "canvas",
                    })),
                    ...(videos[stepId] || []).map((item) => ({
                      ...item,
                      type: "video",
                    })),
                  ]; // Filter out substeps or unwanted items (same as your current filter)
                  const filteredItems = combinedItems.filter(
                    (item) =>
                      !item.substep_id_ref && !item.sub_step_tree_node_id
                  );

                  filteredItems.sort((a, b) => {
                    const orderA =
                      a.sibling_order || a.procedure_tree?.sibling_order;
                    const orderB =
                      b.sibling_order || b.procedure_tree?.sibling_order;

                    const orderCompare = compareSiblingOrders(orderA, orderB);
                    if (orderCompare !== 0) return orderCompare;

                    // Fallback: compare created_at
                    const dateA = new Date(a.created_at);
                    const dateB = new Date(b.created_at);
                    return dateB - dateA; // latest comes first
                  });

                  return (
                    <div
                      className="header-spacing"
                      key={stepId}
                      style={{ marginTop: "20px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            gap: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            onChange={() => {
                              if (
                                selectedStepInfo &&
                                selectedStepInfo.stepId === stepId
                              ) {
                                setSelectedStepInfo(null);
                                setSelectionType(null);
                              } else {
                                // Get accurate sibling order from the step data
                                setSelectedSectionIndex(index);

                                const stepOrder =
                                  step.sibling_order ||
                                  step.procedure_tree?.sibling_order;
                                setSelectedStepInfo({
                                  stepId,
                                  sectionIndex: index,
                                  stepIndex: stepIndex,
                                  globalStepNumber,
                                  direction: null,
                                });
                                setTargetSectionData({
                                  sectionId: section.section_tree_node_id,
                                  siblingOrder: section.sibling_order,
                                  sectionTreeId: section.section_tree_node_id,
                                  stepId,
                                  stepTreeId: step.procedure_tree_ref,
                                  stepSiblingOrder: stepOrder,
                                  step: { ...step }, // Keep the full step data
                                  stepIndex,
                                  globalStepNumber,
                                });
                                setSelectedSectionIndex(null);
                                setSelectionType("step");
                              }
                            }}
                            checked={
                              location.state.fromStepId === stepId ||
                              (selectedStepInfo &&
                                selectedStepInfo.stepId === stepId)
                            }
                            style={
                              location.state.fromStepId === stepId
                                ? {
                                    accentColor: "#444444", // Dark grey for step being moved
                                    backgroundColor: "#444444",
                                  }
                                : {}
                            }
                            disabled={false}
                          />
                          <h2
                            style={{
                              margin: 0,
                              color: "#0066cc",
                              fontSize: "20px",
                            }}
                          >
                            Step {globalStepNumber}
                          </h2>
                        </label>

                        <div
                          style={{
                            color: "#888",
                            fontSize: "14px",
                            fontWeight: "normal",
                          }}
                        >
                          Section {index + 1} &gt; Step {globalStepNumber}
                        </div>
                      </div>

                      <hr />
                      <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                      <p>
                        <p>
                          {structuredClone(step.step_details)
                            .sort(
                              (a, b) =>
                                new Date(a.created_at) - new Date(b.created_at)
                            )
                            .map((myStep, index) => {
                              const partNumber =
                                myStep.part_info?.part_number || "";
                              const description =
                                myStep.part_info?.description || "";
                              const qtyText =
                                myStep.qty && myStep.qty !== 0
                                  ? `Qty ${myStep.qty}`
                                  : "";

                              const partText = partNumber
                                ? ` (${partNumber})`
                                : "";

                              return (
                                <span key={index}>
                                  {myStep.action}
                                  {partText}{" "}
                                  <RenderHtml content={description} /> {qtyText}
                                  &nbsp;
                                </span>
                              );
                            })}
                        </p>
                      </p>

                      <h4>{step.bom_table_title_info?.category_name || ""}</h4>

                      <table className="table">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>
                              {
                                step.part_number_column_title_ref_info
                                  ?.category_name
                              }{" "}
                            </th>
                            <th>Description</th>
                            <th>Qty Per</th>
                            <th>Unit</th>
                          </tr>
                        </thead>

                        <tbody>
                          {step.parts_required.map((row) => (
                            <tr>
                              <td>{row.part_info.type_info.name}</td>
                              <td>{row.part_info.part_number}</td>
                              <td>
                                <RenderHtml
                                  content={row.part_info.description}
                                />
                              </td>
                              <td>{row.qty === 0 ? "" : row.qty}</td>
                              <td>{row.part_info?.unit_info?.unit_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* Step Content */}

                      {filteredItems.map((item) => {
                        if (item.substep_id_ref || item.sub_step_tree_node_id)
                          return null;
                        switch (item.type) {
                          case "richText": {
                            const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                            // render richText block here
                            const label = (
                              <h2 style={{ color: "#333", fontSize: "20px" }}>
                                Rich Text {globalRichTextNumber}
                              </h2>
                            );

                            return (
                              <div
                                className="header-spacing"
                                key={item.rich_text_tree_node_id}
                                style={{ marginTop: "20px" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Section {index + 1} &gt; Step{" "}
                                    {globalStepNumber}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    marginLeft: "5px",
                                    marginTop: "-10px",
                                  }}
                                >
                                  {item.short_description}
                                </div>
                                <div
                                  style={{
                                    marginLeft: "4px",
                                    marginTop: "5px",
                                  }}
                                >
                                  {item.category_data?.category_name}
                                </div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginLeft: "4px",
                                    marginTop: "5px",
                                  }}
                                >
                                  <div
                                    style={{ marginTop: "-6px" }}
                                    dangerouslySetInnerHTML={{
                                      __html: item.rich_text_content,
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          }
                          case "video": {
                            const globalVideoNumber = videoCounter++; // ✅ use then increment
                            const label = (
                              <h2 style={{ color: "#333", fontSize: "20px" }}>
                                Video {globalVideoNumber}
                              </h2>
                            );

                            return (
                              <div
                                className="header-spacing"
                                key={label}
                                style={{ marginTop: "20px" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Section {index + 1} &gt; Step{" "}
                                    {globalStepNumber}
                                  </div>
                                </div>

                                {renderVideo(item)}
                                <div>{item.video_url}</div>

                                <div>{item.short_description}</div>
                              </div>
                            );
                          }

                          case "form": {
                            const globalFormNumber = formCounter++; // ✅ use then increment
                            const label = (
                              <h2 style={{ color: "#333", fontSize: "20px" }}>
                                Form {globalFormNumber}
                              </h2>
                            );
                            // render form block here
                            return (
                              <div key={label}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {label}
                                  </label>
                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Section {index + 1} &gt; Step{" "}
                                    {globalStepNumber}
                                  </div>
                                </div>
                                <div>{item.short_description}</div>
                              </div>
                            );
                          }
                          case "canvas": {
                            const pages = getPages(item);

                            const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                            const label = (
                              <h2 style={{ color: "#333", fontSize: "20px" }}>
                                Canvas {globalCanvasNumber}
                              </h2>
                            );
                            const shapes = item.shapes || [];

                            return (
                              <div
                                className="header-spacing"
                                key={label}
                                style={{ marginTop: "40px" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <h2>{label}</h2>
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Section {index + 1} &gt; Step{" "}
                                    {globalStepNumber}
                                  </div>
                                </div>

                                <div>{item.short_description}</div>

                                {/* Display all pages vertically */}
                                <CanvasDisplay
                                  pages={pages}
                                  hasUserContent={hasUserContent}
                                  getTextStyle={getTextStyle}
                                  stripHtmlPreserveFormatting={
                                    stripHtmlPreserveFormatting
                                  }
                                  estimateKonvaTextHeight={
                                    estimateKonvaTextHeight
                                  }
                                  formatListContent={formatListContent}
                                  hasNoteContent={hasNoteContent}
                                  hasTaskContent={hasTaskContent}
                                  calculateGroupHeight={calculateGroupHeight}
                                  calculateTextBlockWidth={
                                    calculateTextBlockWidth
                                  }
                                />
                              </div>
                            );
                          }
                          case "attachment": {
                            const attachmentList = item.attachments || [];
                            if (attachmentList.length === 0) return null;

                            //  const globalAttachmentNumber =
                            //           attachmentCounter++; // ✅ use then increment
                            const globalAttachmentNumber = attachmentCounter++; // ✅ Increment here per attachment
                            const label = (
                              <h2 style={{ color: "#333", fontSize: "20px" }}>
                                Attachment {globalAttachmentNumber}
                              </h2>
                            );

                            return (
                              <div key={item}>
                                <div
                                  className="header-spacing"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      cursor: "pointer",
                                      marginTop: "20px",
                                    }}
                                  >
                                    {label}
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Section {index + 1} &gt; Step{" "}
                                    {globalStepNumber}
                                  </div>
                                </div>
                                <div>{item.short_description}</div>
                                {attachmentList.map((attachment, i) => (
                                  <div key={i} style={{ marginLeft: "20px" }}>
                                    {renderPreview(attachment)}
                                  </div>
                                ))}
                              </div>
                            );
                          }
                          default:
                            return null;
                        }
                      })}

                      {/* Substeps */}
                      {(substepsByStep[stepId] || []).map(
                        (substep, substepIndex) => {
                          const substepId = substep.sub_step_tree_node_id;
                          const combinedItems = [
                            ...(richTexts[substepId] || []).map((item) => ({
                              ...item,
                              type: "richText",
                            })),
                            ...(forms[substepId] || []).map((item) => ({
                              ...item,
                              type: "form",
                            })),
                            ...(attachments[substepId] || []).map((item) => ({
                              ...item,
                              type: "attachment",
                            })),
                            ...(canvases[substepId] || []).map((item) => ({
                              ...item,
                              type: "canvas",
                            })),
                            ...(videos[substepId] || []).map((item) => ({
                              ...item,
                              type: "video",
                            })),
                          ]; // Filter out substeps or unwanted items (same as your current filter)
                          const filteredItems = combinedItems;

                          filteredItems.sort((a, b) => {
                            const orderA =
                              a.sibling_order ||
                              a.procedure_tree?.sibling_order;
                            const orderB =
                              b.sibling_order ||
                              b.procedure_tree?.sibling_order;

                            const orderCompare = compareSiblingOrders(
                              orderA,
                              orderB
                            );
                            if (orderCompare !== 0) return orderCompare;

                            // Fallback: compare created_at
                            const dateA = new Date(a.created_at);
                            const dateB = new Date(b.created_at);
                            return dateB - dateA; // latest comes first
                          });

                          // Global step number (same logic you already use for steps)
                          const stepsBeforeThisOne =
                            sortedSections
                              .slice(0, index)
                              .reduce((sectionAcc, s) => {
                                const steps =
                                  stepsBySection[s.section_tree_node_id] || [];
                                return sectionAcc + steps.length;
                              }, 0) + stepIndex;

                          const globalStepNumber = stepsBeforeThisOne + 1;

                          // Final substep label like Substep 5A
                          const substepLetter = String.fromCharCode(
                            65 + substepIndex
                          ); // A, B, C, ...

                          const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                          return (
                            <div
                              className="header-spacing"
                              key={substepId}
                              style={{ marginTop: "20px" }}
                            >
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <label
                                    style={{
                                      display: "flex",
                                      gap: "8px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <h2
                                      style={{
                                        margin: 0,
                                        color: "#333",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {globalSubstepLabel}
                                    </h2>
                                  </label>

                                  <div
                                    style={{
                                      color: "#888",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    Section {index + 1} &gt; Step{" "}
                                    {globalStepNumber} &gt; Substep{" "}
                                    {globalStepNumber}
                                    {substepLetter}
                                  </div>
                                </div>

                                <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                              </div>

                              {/* Substep Rich Texts */}
                              {filteredItems.map((item, itemIndex) => {
                                // Determine if this is the source item being moved (within substep)

                                switch (item.type) {
                                  case "richText": {
                                    const currentRichTextNumber =
                                      richTextCounter++;
                                    const richTextId =
                                      item.rich_text_node_id ||
                                      `rich-text-${currentRichTextNumber}`;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Rich Text {currentRichTextNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={richTextId}
                                        style={{ marginTop: "20px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumber} &gt; Substep{" "}
                                            {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        <div
                                          style={{
                                            marginLeft: "5px",
                                            marginTop: "-10px",
                                          }}
                                        >
                                          {item.short_description}
                                        </div>
                                        <div
                                          style={{
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {item.category_data?.category_name}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "14px",
                                            marginLeft: "4px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <div
                                            style={{ marginTop: "-6px" }}
                                            dangerouslySetInnerHTML={{
                                              __html: item.rich_text_content,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                  case "video": {
                                    const currentVideoNumber = videoCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Video {currentVideoNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.video_tree_node_id ||
                                          `video-${currentVideoNumber}`
                                        }
                                        style={{ marginTop: "20px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumber} &gt; Substep{" "}
                                            {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        {renderVideo(item)}

                                        <div>{item.video_url}</div>

                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }

                                  case "form": {
                                    const currentFormNumber = formCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Form {currentFormNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.form_tree_node_id ||
                                          `form-${currentFormNumber}`
                                        }
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumber} &gt; Substep{" "}
                                            {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>
                                        <div>{item.short_description}</div>
                                      </div>
                                    );
                                  }
                                  case "canvas": {
                                    const pages = getPages(item);

                                    const currentCanvasNumber = canvasCounter++;
                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Canvas {currentCanvasNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.canvas_tree_node_id ||
                                          `canvas-${currentCanvasNumber}`
                                        }
                                        style={{ marginTop: "40px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <h2>{label}</h2>
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumber} &gt; Substep{" "}
                                            {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>

                                        {/* Display all pages vertically */}
                                        <CanvasDisplay
                                          pages={pages}
                                          hasUserContent={hasUserContent}
                                          getTextStyle={getTextStyle}
                                          stripHtmlPreserveFormatting={
                                            stripHtmlPreserveFormatting
                                          }
                                          estimateKonvaTextHeight={
                                            estimateKonvaTextHeight
                                          }
                                          formatListContent={formatListContent}
                                          hasNoteContent={hasNoteContent}
                                          hasTaskContent={hasTaskContent}
                                          calculateGroupHeight={
                                            calculateGroupHeight
                                          }
                                          calculateTextBlockWidth={
                                            calculateTextBlockWidth
                                          }
                                        />
                                      </div>
                                    );
                                  }
                                  case "attachment": {
                                    const attachmentList =
                                      item.attachments || [];
                                    if (attachmentList.length === 0)
                                      return null;

                                    const currentAttachmentNumber =
                                      attachmentCounter++;

                                    const label = (
                                      <h2
                                        style={{
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        Attachment {currentAttachmentNumber}
                                      </h2>
                                    );

                                    return (
                                      <div
                                        className="header-spacing"
                                        key={
                                          item.attachment_tree_node_id ||
                                          `attachment-${currentAttachmentNumber}`
                                        }
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <label
                                            style={{
                                              display: "flex",
                                              gap: "6px",
                                              cursor: "pointer",
                                              marginTop: "20px",
                                            }}
                                          >
                                            {label}
                                          </label>

                                          <div
                                            style={{
                                              color: "#888",
                                              fontSize: "14px",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            Section {index + 1} &gt; Step{" "}
                                            {globalStepNumber} &gt; Substep{" "}
                                            {globalStepNumber}
                                            {substepLetter}
                                          </div>
                                        </div>
                                        <div>{item.short_description}</div>
                                        {attachmentList.map((attachment, i) => (
                                          <div
                                            key={i}
                                            style={{ marginLeft: "20px" }}
                                          >
                                            {renderPreview(attachment)}
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  }
                                  default:
                                    return null;
                                }
                              })}
                            </div>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
            </div>
          );
        })}

      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}
      <div style={{ height: "100px" }}></div>
    </div>
  );
};
export default ProcedureStepCopy;
